import Head from 'next/head';
import { Article } from '../components';
import { withLayout } from '../Layout/Layout';
import React from 'react';
import { DestinationPage } from '../components/DestinationPage/DestinationPage';
import { httpGet } from '../utils/httpClient';

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};
let transparentHeader = true;
export const getStaticProps = async ({ params }) => {
  transparentHeader = true;
  const res = await httpGet(
    `${process.env.javaApiUrl}/root/${params.shortlink}`
  );
  const shortLinkRes = await res.json();
  let recommendationRes;
  let recommendation;

  if (shortLinkRes.type === 'ARTICLE') {
    transparentHeader = false;
    recommendationRes = await httpGet(
      `${process.env.javaApiUrl}/recommendation/airlines/articles/${params.id}`
    );
    recommendation = await recommendationRes.json();
  }
  if (shortLinkRes.error) {
    return {
      notFound: true,
      revalidate: 60
    };
  }
  return {
    props: {
      shortLinkRes,
      params,
      recommendation: recommendation ? recommendation : null,
      transparentHeader
    },
    revalidate: 60
  };
};

function RedirectionPage({
                           shortLinkRes,
                           params,
                           recommendation,
                           setLoginDialogState,
                           authCompleted
                         }) {
  switch (shortLinkRes.type) {
    case 'DESTINATION':
      return (
        <div>
          <Head>
            <link
              rel="canonical"
              href={
                shortLinkRes.data.contentMetaData?.canonicalTag ? process.env.apiUrl +
                  shortLinkRes.data.contentMetaData.canonicalTag :
                  `${process.env.apiUrl}/${params.shortlink}`
              }
            />
          </Head>
          <DestinationPage data={{ destination: shortLinkRes.data }} />
        </div>
      );
    case 'ARTICLE': {
      return (
        <div>
          <Head>
            <link
              rel="canonical"
              href={`${process.env.apiUrl}/${params.shortlink}`}
            />
          </Head>
          <Article
            article={shortLinkRes.data}
            recommendation={recommendation}
            setLoginDialogState={setLoginDialogState}
            authCompleted={authCompleted}
          />
        </div>
      );
    }
  }
}

export default withLayout(RedirectionPage, transparentHeader);
